export const findField = (obj, fieldName) => {
  if (!obj || typeof obj !== 'object') return null

  if (Object.prototype.hasOwnProperty.call(obj, fieldName)) {
    return obj[fieldName]
  }

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const result = findField(obj[key], fieldName)
      if (result) return result
    }
  }

  return null
}

export function deriveSeoFromResult(result, pathname) {
  const ctx = result?.pageContext || {}
  const data = result?.data || {}

  const pickPrimary = () => {
    const vals = Object.values(data || {})
    for (const v of vals) {
      if (!v) continue
      if (typeof v === 'object' && !Array.isArray(v)) {
        if (v.seo || v.open_graph || v.user_experience || v.title || v.description) return v
        if (Array.isArray(v.nodes)) {
          const hit = v.nodes.find(n => n && (n.seo || n.open_graph || n.title || n.description))
          if (hit) return hit
        }
      }
      if (Array.isArray(v)) {
        const hit = v.find(n => n && (n.seo || n.open_graph || n.title || n.description))
        if (hit) return hit
      }
    }
    return vals.length === 1 ? vals[0] : {}
  }

  const primary = pickPrimary() || {}
  const seoBlock = primary?.seo || ctx?.seo || {}
  const ogBlock = primary?.open_graph || ctx?.open_graph || {}
  const ux = primary?.user_experience || ctx?.user_experience
  const uxValue = typeof ux === 'string' ? ux : (ux && ux.experience) ? ux.experience : undefined

  const title =
    ctx.title ??
    seoBlock?.meta_title ??
    primary?.title ??
    undefined

  const description =
    ctx.description ??
    seoBlock?.meta_description ??
    primary?.description ??
    undefined

  const keywords = seoBlock?.meta_keywords ?? undefined

  const customMetaTagsRaw = Array.isArray(seoBlock?.custom_meta_tags) ? seoBlock.custom_meta_tags : []
  const customMetaTags = customMetaTagsRaw
    .map(x => ({ name: x?.meta_key, content: x?.meta_value }))
    .filter(x => x.name && x.content && !['description', 'keywords', 'data-institutional'].includes(x.name))

  const openGraph = {
    type: ogBlock?.type || 'website',
    title: ogBlock?.title || title || undefined,
    description: ogBlock?.description || description || undefined,
    url: ogBlock?.url || ctx?.url || undefined,
    image: ogBlock?.image || undefined
  }

  const institutional = uxValue === 'institutional-only' ? true : undefined

  return { title, description, keywords, customMetaTags, openGraph, institutional, pathname }
}

export function brandTitle(base, brand) {
  if (!base && brand) return brand
  if (!base) return ''
  const suffix = ` | ${brand}`
  return base.endsWith(suffix) ? base : `${base}${suffix}`
}
